import { useQuery } from '@tanstack/react-query';

import { fetchData } from 'src/app/queries';

import type { QueryKey } from '@tanstack/react-query';

const vendorsQueryKey: QueryKey = ['vendors'];

const GET_VENDORS = 'api/vendor/get-vendors';

type VendorResponse = {
  ContactEmail: string | null;
  ContactName: string | null;
  ContactPhone: string | null;
  VendorCity: string | null;
  VendorId: number;
  VendorLicense: string | null;
  VendorName: string | null;
  VendorPostalCode: string | null;
  VendorState: string | null;
  VendorStreetAddress: string | null;
};

export function useVendorsQuery<T = VendorResponse[]>(params?: {
  enabled?: boolean;
  select?: (data: VendorResponse[]) => T;
  staleTime?: number;
}) {
  const { enabled, staleTime, select } = params ?? {};

  return useQuery({
    queryKey: vendorsQueryKey,
    queryFn: () => fetchData<VendorResponse[]>(GET_VENDORS),
    enabled,
    staleTime,
    select,
  });
}
